<template>
    <VirtualScroller :items="['Report']" :itemSize="1" style="height: calc(100vh - 208px - 4rem);" showLoader
        id="report">
        <template v-slot:item="{ item, options }">
            <div class="page">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">
                        Version No.:
                        <InputLabel :data="userInput.general.versionNo" :show="printMode" :width="'30px'"
                            @input="(e) => userInput.general.versionNo = e" />
                        (Date:
                        <InputLabel :data="userInput.general.date" :show="printMode" :width="'80px'"
                            @input="(e) => userInput.general.date = e" />)
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:
                        <InputLabel :data="userInput.general.lastUpdate" :show="printMode" :width="'80px'"
                            @input="(e) => userInput.general.lastUpdate = e" />
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0">
                        <h3 class="center">CONSTRUCTION NOISE MANAGEMENT PLAN</h3>
                    </div>
                    <table class="table">
                        <tr class="header">
                            <th colspan="5">
                                GENERAL INFORMATION
                            </th>
                        </tr>
                        <tr>
                            <td>Project Title:<br>{{ project.projectTitle }}</td>
                            <td>Contract/ Agreement:<br>{{ project.agreement }}</td>
                            <td>Project Proponent:<br>{{ project.proponent }}</td>
                            <td>Main Contractor:<br>{{ project.mainContractor }}</td>
                            <td>Engineer Consultant:<br>{{ project.engineerConsultant }}</td>
                        </tr>
                        <tr>
                            <td colspan="2">Commencement Date: {{ project.commencementDate }}</td>
                            <td colspan="3">Expected Completion Date: {{ project.completionDate }}</td>
                        </tr>
                        <tr>
                            <td colspan="1">Project Description:</td>
                            <td colspan="4">{{ project.description }}</td>
                        </tr>
                        <tr>
                            <td colspan="1">Special Features:</td>
                            <td colspan="4">{{ project.specialFeature }}</td>
                        </tr>
                    </table>
                    <table class="table">
                        <tr class="header">
                            <th colspan="3">
                                CONSTRUCTION PERMIT OR APPROVAL
                            </th>
                        </tr>
                        <tr>
                            <td class="sub-header">Permit or Approval</td>
                            <td class="sub-header">Status of Application</td>
                            <td class="sub-header">Details</td>
                        </tr>
                        <tr>
                            <td>Construction Noise Permit</td>
                            <td>
                                <DropdownLabel :data="userInput.cpoa.cnp.status" :options="userInput.cpoa.status"
                                    :show="printMode" :width="'100%'" @change="(e) => userInput.cpoa.cnp.status = e" />
                            </td>
                            <td>
                                <InputLabel :data="userInput.cpoa.cnp.details" :show="printMode" :width="'100%'"
                                    @input="(e) => userInput.cpoa.cnp.details = e" />
                            </td>
                        </tr>
                        <tr>
                            <td>Environmental Permit</td>
                            <td>
                                <DropdownLabel :data="userInput.cpoa.ep.status" :options="userInput.cpoa.status"
                                    :show="printMode" :width="'100%'" @change="(e) => userInput.cpoa.ep.status = e" />
                            </td>
                            <td>
                                <InputLabel :data="userInput.cpoa.ep.details" :show="printMode" :width="'100%'"
                                    @input="(e) => userInput.cpoa.ep.details = e" />
                            </td>
                        </tr>
                        <tr>
                            <td>Excavation Permit</td>
                            <td>
                                <DropdownLabel :data="userInput.cpoa.exp.status" :options="userInput.cpoa.status"
                                    :show="printMode" :width="'100%'" @change="(e) => userInput.cpoa.exp.status = e" />
                            </td>
                            <td>
                                <InputLabel :data="userInput.cpoa.exp.details" :show="printMode" :width="'100%'"
                                    @input="(e) => userInput.cpoa.exp.details = e" />
                            </td>
                        </tr>
                        <tr>
                            <td>Demolition Permit</td>
                            <td>
                                <DropdownLabel :data="userInput.cpoa.dp.status" :options="userInput.cpoa.status"
                                    :show="printMode" :width="'100%'" @change="(e) => userInput.cpoa.dp.status = e" />
                            </td>
                            <td>
                                <InputLabel :data="userInput.cpoa.dp.details" :show="printMode" :width="'100%'"
                                    @input="(e) => userInput.cpoa.dp.details = e" />
                            </td>
                        </tr>
                        <tr>
                            <td>Other:
                                <InputLabel :data="userInput.cpoa.other.name" :show="printMode" :width="'150px'"
                                    @input="(e) => userInput.cpoa.other.name = e" />
                            </td>
                            <td>
                                <DropdownLabel :data="userInput.cpoa.other.status" :options="userInput.cpoa.status"
                                    :show="printMode" :width="'100%'"
                                    @change="(e) => userInput.cpoa.other.status = e" />
                            </td>
                            <td>
                                <InputLabel :data="userInput.cpoa.other.details" :show="printMode" :width="'100%'"
                                    @input="(e) => userInput.cpoa.other.details = e" />
                            </td>
                        </tr>
                    </table>
                    <table class="table">
                        <tr class="header">
                            <th colspan="2">
                                CONSTRUCTION NOISE ASSESSMENT
                            </th>
                        </tr>
                        <tr>
                            <td>
                                <input type="radio" name="assessmentStatus" aria-label="Done">Done
                            </td>
                            <td>
                                <input type="radio" aria-label="Not Applicable" name="assessmentStatus"
                                    :checked="userInput.cna.reason != ''">
                                Not Applicable (Reason:
                                <InputLabel aria-label="Reason" :data="userInput.cna.reason" :show="printMode"
                                    :width="'70%'" @input="(e) => userInput.cna.reason = e" />)
                            </td>
                        </tr>
                    </table>
                    <table class="table">
                        <tr class="header">
                            <th colspan="3">
                                RECOMMENDED TRIGGER POINT FOR CONTINUOUS REVIEW ON THIS PLAN
                            </th>
                        </tr>
                        <tr>
                            <td><input type="checkbox" aria-label="Limit Level Exceedance (1)">Limit Level Exceedance
                                (1)</td>
                            <td><input type="checkbox" aria-label="Action Level Exceedance (3)">Action Level Exceedance
                                (3)</td>
                            <td><input type="checkbox"
                                    aria-label="Violation of Permit. License,Approval or Legislation (5)">Violation of
                                Permit. License,Approval or Legislation (5)</td>
                        </tr>
                        <tr>
                            <td><input type="checkbox" aria-label="Assumption Amendment (2)">Assumption Amendment (2)
                            </td>
                            <td><input type="checkbox" aria-label="Noise Deficiency Observation (4)">Noise Deficiency
                                Observation (4)</td>
                            <td><input type="checkbox" aria-label="Others">Others:
                                <InputLabel :data="userInput.rtp.other" :show="printMode" aria-label="Others"
                                    :width="'150px'" @input="(e) => userInput.rtp.other = e" />
                            </td>
                        </tr>
                    </table>
                    <table class="table">
                        <tr class="header">
                            <th>
                                DOCUMENTS IN THIS PLAN
                            </th>
                        </tr>
                        <tr>
                            <td>
                                <div class="formgrid grid">
                                    <div class="col-12 md:col-6">
                                        <input type="checkbox" aria-label="Quieter Construction Method and Equipment">
                                        Quieter Construction Method and Equipment
                                    </div>
                                    <div class="col-12 md:col-6">
                                        <input type="checkbox"
                                            aria-label="Construction Noise Impacts and its Compliance">
                                        Construction Noise Impacts and its Compliance
                                    </div>
                                    <div class="col-12 md:col-6">
                                        <input type="checkbox" aria-label="Construction Noise Mitigation Measures">
                                        Construction Noise Mitigation Measures
                                    </div>
                                    <div class="col-12 md:col-6">
                                        <input type="checkbox" aria-label="Noise Monitoring Plan">
                                        Noise Monitoring Plan
                                    </div>
                                    <div class="col-12 md:col-6">
                                        <input type="checkbox" aria-label="Construction Work Schedule">
                                        Construction Work Schedule
                                    </div>
                                    <div class="col-12 md:col-6">
                                        <input type="checkbox" aria-label="Site Layout Map with NSRs">
                                        Site Layout Map with NSRs
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                    <table class="table">
                        <tr class="header">
                            <th>
                                ADDITIONAL INFORMATION
                            </th>
                        </tr>
                        <tr>
                            <td>
                                <InputLabel :data="userInput.additionalInfo" :show="printMode" :width="'100%'"
                                    @input="(e) => userInput.additionalInfo = e" /><br>
                            </td>
                        </tr>
                    </table>
                    <div class="col-12">Prepared by:
                        <InputLabel :data="userInput.prepared.by" :show="printMode" :width="'100px'"
                            @input="(e) => userInput.prepared.by = e" /> (Date:
                        <InputLabel :data="userInput.prepared.date" :show="printMode" :width="'80px'"
                            @input="(e) => userInput.prepared.date = e" />)
                    </div>
                    <div class="col-12">Checked by:
                        <InputLabel :data="userInput.checked.by" :show="printMode" :width="'100px'"
                            @input="(e) => userInput.checked.by = e" /> (Date:
                        <InputLabel :data="userInput.checked.date" :show="printMode" :width="'80px'"
                            @input="(e) => userInput.checked.date = e" />)
                    </div>
                </div>
            </div>
            <div class="page" v-if="qcmList.length > 0 || qpmeList.length > 0 || mitigationList.length > 0">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">Version No.:{{ userInput.general.versionNo }} (Date: {{
                        userInput.general.date
                        }})
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:{{ userInput.general.lastUpdate }}</div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0">
                        <h3 class="center">QUIETER CONSTRUCTION METHOD AND EQUIPMENT</h3>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0" v-if="qcmList.length > 0">
                        List of Quieter Construction Method identified
                    </div>
                    <div class="table css-table" v-if="qcmList.length > 0">
                        <div class="header css-tr">
                            <div class="css-th" style="width:50%">Activity</div>
                            <div class="css-th">Quieter Construction Method</div>
                        </div>
                        <template v-for="qpme in qcmList">
                            <div class="css-tr">
                                <div class="css-td">{{ qpme.activity }}</div>
                                <div class="css-td">{{ qpme.name }}</div>
                            </div>
                        </template>
                    </div>
                    <div class="field col-12 md:col-12" v-if="getCredit">&#x2713 BEAM Plus credit (3 dB(A) noise
                        reduction
                        due to more than 2 quieter construction methods)</div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0"
                        v-if="qpmeList.length > 0 && qcmList.length <= 20">
                        List of Quality Powered Mechanical Equipment identified
                    </div>
                    <div class="table css-table" v-if="qpmeList.length > 0 && qcmList.length <= 20">
                        <div class="header css-tr">
                            <div class="css-th" style="width:50%">Activity</div>
                            <div class="css-th">Quality Powered Mechanical Equipment</div>
                        </div>
                        <template v-for="qpme in qpmeList">
                            <div class="css-tr">
                                <div class="css-td">{{ qpme.activity }}</div>
                                <div class="css-td">{{ qpme.name }}</div>
                            </div>
                        </template>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0"
                        v-if="mitigationList.length > 0 && qpmeList.length + qcmList.length <= 20">
                        List of Construction Noise Mitigation identified
                    </div>
                    <div class="table css-table"
                        v-if="mitigationList.length > 0 && qpmeList.length + qcmList.length <= 20">
                        <div class="header css-tr">
                            <div class="css-th" style="width:50%">Activity</div>
                            <div class="css-th">Construction Noise Mitigation</div>
                        </div>
                        <template v-for="qpme in mitigationList">
                            <div class="css-tr">
                                <div class="css-td">{{ qpme.activity }}</div>
                                <div class="css-td">{{ qpme.name }}</div>
                            </div>
                        </template>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0"
                        v-if="qpmeList.length + qpmeList.length + qcmList.length <= 20">
                        <h3 class="center">CONSTRUCTION NOISE MITIGATION MEASURES</h3>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0"
                        v-if="qpmeList.length + qpmeList.length + qcmList.length <= 20">
                        List of Construction Noise Mitigation Measures identified
                    </div>
                    <table class="table" v-if="qpmeList.length <= 20">
                        <tr>
                            <td>
                                <div><input type="checkbox" :checked="qcmList.length > 0"
                                        aria-label="Use of Quieter Construction Method">Use of
                                    Quieter
                                    Construction Method</div>
                                <div><input type="checkbox" :checked="qpmeList.length > 0"
                                        aria-label="Use of Quality Powered Mechanical Equipment (QPME)">Use
                                    of Quality
                                    Powered Mechanical
                                    Equipment (QPME)</div>
                                <div><input type="checkbox" aria-label="Construction Noise Enclosure"
                                        :checked="project.equipments.filter(e => e.enclosureDba != 0).length > 0">Construction
                                    Noise Enclosure</div>
                                <div><input type="checkbox" aria-label="Noise Barrier"
                                        :checked="project.equipments.filter(e => e.barrierDba != 0).length > 0">Noise
                                    Barrier
                                </div>
                                <template
                                    v-for="customMethod in [...new Set(project.equipments.filter(e => e.custommethodname).map(e => e.custommethodname).flat())]">
                                    <div><input type="checkbox" :checked="true" aria-label="Custom Method">
                                        {{ customMethod.trim() }}
                                    </div>
                                </template>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="page" v-if="qcmList.length > 20 && (qpmeList.length > 0 || mitigationList.length > 0)">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">Version No.:{{ userInput.general.versionNo }} (Date: {{
                        userInput.general.date
                        }})
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:{{ userInput.general.lastUpdate }}</div>
                    <br>
                    <br>
                    <div class="field col-12 md:col-12" style="margin-bottom:0" v-if="qpmeList.length > 0">
                        List of Quality Powered Mechanical Equipment identified
                    </div>
                    <div class="table css-table" v-if="qpmeList.length > 0">
                        <div class="header css-tr">
                            <div class="css-th" style="width:50%">Activity</div>
                            <div class="css-th">Quality Powered Mechanical Equipment</div>
                        </div>
                        <template v-for="qpme in qpmeList">
                            <div class="css-tr">
                                <div class="css-td">{{ qpme.activity }}</div>
                                <div class="css-td">{{ qpme.name }}</div>
                            </div>
                        </template>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0"
                        v-if="mitigationList.length > 0 && qpmeList.length <= 20">
                        List of Construction Noise Mitigation identified
                    </div>
                    <div class="table css-table" v-if="mitigationList.length > 0 && qpmeList.length <= 20">
                        <div class="header css-tr">
                            <div class="css-th" style="width:50%">Activity</div>
                            <div class="css-th">Construction Noise Mitigation</div>
                        </div>
                        <template v-for="qpme in mitigationList">
                            <div class="css-tr">
                                <div class="css-td">{{ qpme.activity }}</div>
                                <div class="css-td">{{ qpme.name }}</div>
                            </div>
                        </template>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0"
                        v-if="qpmeList.length + qpmeList.length <= 20">
                        <h3 class="center">CONSTRUCTION NOISE MITIGATION MEASURES</h3>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0"
                        v-if="qpmeList.length + qpmeList.length <= 20">
                        List of Construction Noise Mitigation Measures identified
                    </div>
                    <table class="table" v-if="qpmeList.length <= 20">
                        <tr>
                            <td>
                                <div><input type="checkbox" aria-label="Use of Quieter Construction Method"
                                        :checked="qcmList.length > 0">Use of
                                    Quieter
                                    Construction Method</div>
                                <div><input type="checkbox" :checked="qpmeList.length > 0"
                                        aria-label="Use of Quality Powered Mechanical Equipment (QPME)">Use
                                    of Quality
                                    Powered Mechanical
                                    Equipment (QPME)</div>
                                <div><input type="checkbox" aria-label="Construction Noise Enclosure"
                                        :checked="project.equipments.filter(e => e.enclosureDba != 0).length > 0">Construction
                                    Noise Enclosure</div>
                                <div><input type="checkbox" aria-label="Noise Barrier"
                                        :checked="project.equipments.filter(e => e.barrierDba != 0).length > 0">Noise
                                    Barrier
                                </div>
                                <template
                                    v-for="customMethod in [...new Set(project.equipments.filter(e => e.custommethodname).map(e => e.custommethodname).flat())]">
                                    <div><input type="checkbox" :checked="true" aria-label="Custom Method">
                                        {{ customMethod.trim() }}
                                    </div>
                                </template>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="page" v-if="qcmList.length + qpmeList.length > 20 && mitigationList.length > 0">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">Version No.:{{ userInput.general.versionNo }} (Date: {{
                        userInput.general.date
                        }})
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:{{ userInput.general.lastUpdate }}</div>
                    <br>
                    <br>
                    <div class="field col-12 md:col-12" style="margin-bottom:0">
                        List of Construction Noise Mitigation identified
                    </div>
                    <div class="table css-table">
                        <div class="header css-tr">
                            <div class="css-th" style="width:50%">Activity</div>
                            <div class="css-th">Construction Noise Mitigation</div>
                        </div>
                        <template v-for="qpme in mitigationList">
                            <div class="css-tr">
                                <div class="css-td">{{ qpme.activity }}</div>
                                <div class="css-td">{{ qpme.name }}</div>
                            </div>
                        </template>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0" v-if="mitigationList.length <= 20">
                        <h3 class="center">CONSTRUCTION NOISE MITIGATION MEASURES</h3>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0" v-if="mitigationList.length <= 20">
                        List of Construction Noise Mitigation Measures identified
                    </div>
                    <table class="table" v-if="mitigationList.length <= 20">
                        <tr>
                            <td>
                                <div><input type="checkbox" :checked="qcmList.length > 0"
                                        aria-label="Use of Quieter Construction Method">Use of
                                    Quieter
                                    Construction Method</div>
                                <div><input type="checkbox" :checked="qpmeList.length > 0" aria-label="Use
                                    of Quality
                                    Powered Mechanical
                                    Equipment (QPME)">Use
                                    of Quality
                                    Powered Mechanical
                                    Equipment (QPME)</div>
                                <div><input type="checkbox" aria-label="Construction Noise Enclosure"
                                        :checked="project.equipments.filter(e => e.enclosureDba != 0).length > 0">Construction
                                    Noise Enclosure</div>
                                <div><input type="checkbox" aria-label="Noise Barrier"
                                        :checked="project.equipments.filter(e => e.barrierDba != 0).length > 0">Noise
                                    Barrier
                                </div>
                                <template
                                    v-for="customMethod in [...new Set(project.equipments.filter(e => e.custommethodname).map(e => e.custommethodname).flat())]">
                                    <div><input type="checkbox" :checked="true" aria-label="Custom Method">
                                        {{ customMethod.trim() }}
                                    </div>
                                </template>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="page"
                v-if="!(qcmList.length + qpmeList.length + mitigationList.length <= 20 || (qcmList.length > 20 && qpmeList.length + mitigationList.length <= 20) || (qcmList.length + qpmeList.length > 20 && mitigationList.length <= 20)) || (qcmList.length == 0 && qpmeList.length == 0 && mitigationList.length == 0)">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">Version No.:{{ userInput.general.versionNo }} (Date: {{
                        userInput.general.date
                        }})
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:{{ userInput.general.lastUpdate }}</div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0">
                        <h3 class="center">CONSTRUCTION NOISE MITIGATION MEASURES</h3>
                    </div>
                    <div class="field col-12 md:col-12" style="margin-bottom:0">
                        List of Construction Noise Mitigation Measures identified
                    </div>
                    <table class="table">
                        <tr>
                            <td>
                                <div><input type="checkbox" :checked="qcmList.length > 0"
                                        aria-label="Use of Quieter Construction Method">Use of
                                    Quieter
                                    Construction Method</div>
                                <div><input type="checkbox" :checked="qpmeList.length > 0" aria-label="Use
                                    of Quality
                                    Powered Mechanical
                                    Equipment (QPME)">Use
                                    of Quality
                                    Powered Mechanical
                                    Equipment (QPME)</div>
                                <div><input type="checkbox" aria-label="Construction Noise Enclosure"
                                        :checked="project.equipments.filter(e => e.enclosureDba != 0).length > 0">Construction
                                    Noise Enclosure</div>
                                <div><input type="checkbox" aria-label="Noise Barrier"
                                        :checked="project.equipments.filter(e => e.barrierDba != 0).length > 0">Noise
                                    Barrier
                                </div>
                                <template
                                    v-for="customMethod in [...new Set(project.equipments.filter(e => e.custommethodname).map(e => e.custommethodname).flat())]">
                                    <div><input type="checkbox" aria-label="Custom Method" :checked="true">
                                        {{ customMethod.trim() }}
                                    </div>
                                </template>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="page" v-for="(tasks, page) in splitToPages(project.tasks, 22, 27)">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">Version No.:{{ userInput.general.versionNo }} (Date: {{
                        userInput.general.date
                        }})
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:{{ userInput.general.lastUpdate }}</div>
                    <br>
                    <br>
                    <div class="field col-12 md:col-12" style="margin-bottom:0" v-if="page == 0">
                        <h3 class="center">CONSTRUCTION WORK SCHEDULE</h3>
                    </div>
                    <div class="field col-12 md:col-12" v-if="page == 0">
                        Construction work schedule determines the noise impacts to the surrounding community. Therefore,
                        it
                        is
                        important to consider the construction time, number of powered mechanical equipment used and the
                        construction location at the same time, so that cumulative noise impacts by the construction
                        activity
                        could
                        be
                        minimised. It is important to prevent the use of the noisy construction equipment or
                        construction
                        activity,
                        if
                        infeasible, scheduling construction work at less noise sensitive time is highly recommended.
                    </div>
                    <div class="field col-12 md:col-12" v-if="page == 0">
                        <u>Construction Project</u>
                    </div>
                    <div class="table css-table">
                        <div class="header css-tr">
                            <div class="css-th">Construction Activity</div>
                            <div class="css-th">Phase of Work</div>
                            <div class="css-th">Zoning</div>
                            <div class="css-th">Date</div>
                        </div>
                        <template v-for="task in tasks">
                            <div class="css-tr">
                                <div class="css-td">{{ task.name }}</div>
                                <div class="css-td">{{ task.group }}</div>
                                <div class="css-td" style="min-width:50px">{{project.zones.filter(z => z.id ==
                                    task.zone)[0].name}}</div>
                                <div class="css-td" style="min-width:130px">{{ `${task.start} - ${task.end}` }}</div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="page"
                v-for="(calcResultDetailsUnmitigated, page) in splitToPages(calcResultDetailsUnmitigatedCleaned, getMaxConstructionActivityTaskLength(calcResultDetailsUnmitigatedCleaned) > 100 ? 22 : 28, getMaxConstructionActivityTaskLength(calcResultDetailsUnmitigatedCleaned) > 100 ? 22 : 28)">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">Version No.:{{ userInput.general.versionNo }} (Date: {{
                        userInput.general.date
                        }})
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:{{ userInput.general.lastUpdate }}</div>
                    <br>
                    <br>
                    <div class="field col-12 md:col-12" v-if="page == 0">
                        <u>Cumulative Impact of PMEs in each phase of work</u>
                    </div>
                    <div class="table css-table">
                        <div class="header css-tr">
                            <div class="css-th" :style="{
                                width: (getMaxConstructionActivityTaskLength(calcResultDetailsUnmitigatedCleaned) > 100 ? 300 : 200) + 'px'
                            }">
                                Construction Activity</div>
                            <div class="css-th">Types of PME</div>
                            <div class="css-th" style="width:70px">Sound Power Level</div>
                            <div class="css-th" style="width:30px">Qty</div>
                            <div class="css-th" style="width:40px">Time %</div>
                            <div class="css-th" style="width:70px">Cumulative Noise Impact</div>
                        </div>
                        <template v-for="calcResultDetail in calcResultDetailsUnmitigated">
                            <div class="css-tr">
                                <div class="css-td">
                                    {{
                                        getConstructionActivityTask(calcResultDetail)
                                    }}
                                </div>
                                <div class="css-td">{{
                                    calcResultDetail.pmeref != '' ?
                                        `${calcResultDetail.pmeref} - ${calcResultDetail.pmename}` :
                                        calcResultDetail.pmename
                                    }}</div>
                                <div class="number css-td">{{ calcResultDetail.swl }}</div>
                                <div class="number css-td">{{ calcResultDetail.qty }}</div>
                                <div class="number css-td">{{ calcResultDetail.timepercent }}</div>
                                <div class="number css-td">{{ Math.round(calcResultDetail.totalswl) }}</div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="page"
                v-for="(buildingids, page) in splitToPages(Object.keys(nsrMitigated).sort((a, b) => (nsrMitigated[a].nsrname.localeCompare(nsrMitigated[b].nsrname, undefined, { numeric: true, sensitivity: 'base' }))), 32, 35)">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">Version No.:{{ userInput.general.versionNo }} (Date: {{
                        userInput.general.date
                        }})
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:{{ userInput.general.lastUpdate }}</div>
                    <br>
                    <br>
                    <div class="field col-12 md:col-12" style="margin-bottom:0" v-if="page == 0">
                        <h3 class="center">CONSTRUCTION NOISE IMPACTS AND ITS COMPLIANCE</h3>
                    </div>
                    <div class="col-12 md:col-12">
                        <div class="table css-table">
                            <div class="header css-tr">
                                <div class="css-th" style="width: 70px;">NSR Label</div>
                                <div class="css-th" style="width: 190px;">Descriptions</div>
                                <div class="css-th"
                                    :style="{ width: (Object.values(nsrMitigated).map(n => n.othernoisecriteriaexceedmax).filter(n => n != '').length > 0 ? 150 : 70) + 'px' }">
                                    Noise Criteria, dB(A)</div>
                                <div class="css-th" style="width: 60px">Mitigated Noise Level, dB(A)</div>
                                <div class="css-th" style="width: 60px">Exceedance, dB(A)</div>
                                <div class="css-th" style="width: 90px">Duration of Exceedance</div>
                                <div class="css-th">Reason</div>
                            </div>
                            <template v-for="id in buildingids">
                                <div class="css-tr">
                                    <div class="css-td">{{ nsrMitigated[id].nsrname }}</div>
                                    <div class="css-td">{{ nsrMitigated[id].buildingName }}</div>
                                    <div class="number css-td">
                                        {{ nsrMitigated[id].noiseCriteria }}
                                    </div>
                                    <div class="number css-td">{{ Math.round(nsrMitigated[id].highestnoiselevel * 10) /
                                        10
                                        }}
                                    </div>
                                    <div class="number css-td">
                                        {{
                                            getExceeding(nsrMitigated[id])
                                        }}
                                    </div>
                                    <div class="number css-td">
                                        {{ getExceeding(nsrMitigated[id]) != '-' ?
                                            `${getExceedingDuration(nsrMitigated[id])} days` : '-'
                                        }}
                                    </div>
                                    <div class="css-td" v-if="getExceeding(nsrMitigated[id]) != '-'">
                                        <InputLabel :data="nsrMitigated[id].exceedReason" :show="printMode"
                                            :width="'100%'" @input="(e) => nsrMitigated[id].exceedReason = e" />
                                    </div>
                                    <div class="css-td" v-else>-</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page" v-if="project.nsrPointHistory.length"
                v-for="(buildingids, page) in splitToPages(Object.keys(nsrMitigated).sort((a, b) => (nsrMitigated[a].nsrname.localeCompare(nsrMitigated[b].nsrname, undefined, { numeric: true, sensitivity: 'base' }))), 32, 35)">
                <div class="formgrid grid">
                    <div class="col-12 md:col-4">Version No.:{{ userInput.general.versionNo }} (Date: {{
                        userInput.general.date
                        }})
                    </div>
                    <div class="col-12 md:col-4"></div>
                    <div class="col-12 md:col-4">Reason(s) of Last Update:{{ userInput.general.lastUpdate }}</div>
                    <br>
                    <br>
                    <div class="field col-12 md:col-12" style="margin-bottom:0" v-if="page == 0">
                        <h3 class="center">NOISE SENSITIVE RECEIVER CHANGES ON THE MOVEMENT AND DELETION</h3>
                    </div>
                    <div class="col-12 md:col-12">
                        <div class="table css-table">
                            <div class="header css-tr">
                                <div class="css-th" style="width: 70px;">NSR Label</div>
                                <div class="css-th">Descriptions</div>
                                <div class="css-th" style="width: 150px">Original Location</div>
                                <div class="css-th" style="width: 150px">Current Location</div>
                            </div>
                            <template v-for="id in buildingids">
                                <div class="css-tr"
                                    v-if="project.nsrPointHistory.filter(h => h.id === nsrMitigated[id].nsrpointid).length">
                                    <div class="css-td">{{ nsrMitigated[id].nsrname }}</div>
                                    <div class="css-td">{{ nsrMitigated[id].buildingName }}</div>
                                    <div class="number css-td">
                                        {{`${Math.round(project.nsrPointHistory.filter(h => h.id ===
                                            nsrMitigated[id].nsrpointid)[0].oldx * 100) /
                                            100}, ${Math.round(project.nsrPointHistory.filter(h => h.id
                                                === nsrMitigated[id].nsrpointid)[0].oldy * 100) / 100} `}}
                                    </div>
                                    <div class="number css-td">{{`${Math.round(project.nsrPointHistory.filter(h => h.id
                                        ===
                                        nsrMitigated[id].nsrpointid)[project.nsrPointHistory.filter(h => h.id ===
                                            nsrMitigated[id].nsrpointid).length - 1].x * 100) /
                                        100}, ${Math.round(project.nsrPointHistory.filter(h => h.id
                                            === nsrMitigated[id].nsrpointid)[project.nsrPointHistory.filter(h => h.id ===
                                                nsrMitigated[id].nsrpointid).length - 1].y * 100) / 100} ` }}
                                    </div>
                                </div>
                            </template>
                            <template
                                v-for="history in project.nsrPointHistory.filter(h => h.oldx === h.x && h.oldy === h.y)">
                                <div class="css-tr">
                                    <div class="css-td">-</div>
                                    <div class="css-td">{{ history.buildingName || history.id }}</div>
                                    <div class="number css-td">
                                        {{ `${Math.round(history.oldx * 100) /
                                            100}, ${Math.round(history.oldy * 100) / 100} ` }}
                                    </div>
                                    <div class="number css-td">Deleted</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page">
                <div class="formgrid grid">
                    <div class="field col-12 md:col-12" style="margin-bottom:0">
                        <h3 class="center">CONSTRUCTION NOISE MONITORING</h3>
                    </div>
                    <table class="table">
                        <tr class="header">
                            <th colspan="2">CONSTRUCTION NOISE MONITORING</th>
                        </tr>
                        <tr>
                            <td>Construction Noise Monitoring</td>
                            <td>
                                <div class="formgrid grid">
                                    <div class="col-12 md:col-4">
                                        <input type="checkbox" aria-label="Regular Monitoring">
                                        Regular Monitoring
                                    </div>
                                    <div class="col-12 md:col-4">
                                        <input type="checkbox" aria-label="Continuous Monitoring">
                                        Continuous Monitoring
                                    </div>
                                    <div class="col-12 md:col-4">
                                        <input type="checkbox" aria-label="Site Inspection">
                                        Site Inspection
                                    </div>
                                    <div class="col-12">
                                        <input type="checkbox" aria-label="Others"
                                            :checked="userInput.cnm.cnm.others != ''">
                                        Others:
                                        <InputLabel :data="userInput.cnm.cnm.others" aria-label="Others"
                                            :show="printMode" :width="'70%'"
                                            @input="(e) => userInput.cnm.cnm.others = e" />
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Public Engagement and Advance Notification</td>
                            <td>
                                <div class="formgrid grid">
                                    <div class="col-12 md:col-3">
                                        <input type="checkbox" aria-label="Newsletter">
                                        Newsletter
                                    </div>
                                    <div class="col-12 md:col-3">
                                        <input type="checkbox" aria-label="Mail Drop-off">
                                        Mail Drop-off
                                    </div>
                                    <div class="col-12 md:col-3">
                                        <input type="checkbox" aria-label="Project Website">
                                        Project Website
                                    </div>
                                    <div class="col-12 md:col-3">
                                        <input type="checkbox" aria-label="Phone Call">
                                        Phone Call
                                    </div>
                                    <div class="col-12 md:col-3">
                                        <input type="checkbox" aria-label="Individual Briefing">
                                        Individual Briefing
                                    </div>
                                    <div class="col-12 md:col-3">
                                        <input type="checkbox" aria-label="Billboards">
                                        Billboards
                                    </div>
                                    <div class="col-12 md:col-3">
                                        <input type="checkbox" aria-label="Community Meeting">
                                        Community Meeting
                                    </div>
                                    <div class="col-12">
                                        <input type="checkbox" aria-label="Others"
                                            :checked="userInput.cnm.pean.others != ''">
                                        Others:
                                        <InputLabel :data="userInput.cnm.pean.others" aria-label="Others"
                                            :show="printMode" :width="'70%'"
                                            @input="(e) => userInput.cnm.pean.others = e" />
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Complaint Handling Mechanism</td>
                            <td>
                                <div class="formgrid grid">
                                    <div class="col-12 md:col-4">
                                        <input type="checkbox" aria-label="Organisation Chart">
                                        Organisation Chart
                                    </div>
                                    <div class="col-12 md:col-4">
                                        <input type="checkbox" aria-label="Complaint Hotline">
                                        Complaint Hotline
                                    </div>
                                    <div class="col-12 md:col-4">
                                        <input type="checkbox" aria-label="Liaison Office">
                                        Liaison Office
                                    </div>
                                    <div class="col-12">
                                        <input type="checkbox" aria-label="Others"
                                            :checked="userInput.cnm.cnm.others != ''">
                                        Others:
                                        <InputLabel :data="userInput.cnm.cnm.others" aria-label="Others"
                                            :show="printMode" :width="'70%'"
                                            @input="(e) => userInput.cnm.cnm.others = e" />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </template>
    </VirtualScroller>
</template>

<script>
import InputLabel from "./InputLabel.vue"
import DropdownLabel from "./DropdownLabel.vue"
import DateHelper from "@/helper/DateHelper"
export default {
    name: 'Report',
    props: {
        project: Object,
        printMode: Boolean,
        userInput: Object,
    },
    data() {
        return {
            qcmList: [],
            qpmeList: [],
            mitigationList: [],
            nsrUnmitigated: {},
            nsrMitigated: {},
            calcResultDetailsUnmitigatedCleaned: []
        }
    },
    computed: {
        getTotalDays() {
            return (DateHelper.getDate(this.project.completionDate).getTime() - DateHelper.getDate(this.project.commencementDate).getTime()) / (1000 * 3600 * 24)
        },
        getTotalWeeks() {
            return (DateHelper.getDate(this.project.completionDate).getTime() - DateHelper.getDate(this.project.commencementDate).getTime()) / (1000 * 3600 * 24 * 7)
        },
        getTotalMonths() {
            let d1 = DateHelper.getDate(this.project.commencementDate);
            let d2 = DateHelper.getDate(this.project.completionDate);
            let months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        },
        getCredit() {
            let props = this;
            let qcm = this.project.equipments.filter(e => e.isQCM);
            let buildingIds = Object.keys(this.nsrMitigated);
            return qcm.length >= 2 && buildingIds.some(id => props.nsrUnmitigated[id].highestnoiselevel - props.nsrMitigated[id].highestnoiselevel >= 3);
        },
    },
    methods: {
        getDateString(date) {
            return DateHelper.getDateString(date);
        },
        getDate(date) {
            return DateHelper.getDate(date)
        },
        getConstructionActivity(taskId) {
            return this.project.tasks.filter(t => t.id == taskId)[0].group;
        },
        getTaskName(taskId) {
            return this.project.tasks.filter(t => t.id == taskId)[0].name;
        },
        getConstructionActivityTask(calcResultDetail) {
            return this.getConstructionActivity(calcResultDetail.taskid) == "-" ?
                this.getTaskName(calcResultDetail.taskid) :
                `${this.getConstructionActivity(calcResultDetail.taskid)}
                                                                        - ${this.getTaskName(calcResultDetail.taskid)}`
        },
        getMaxConstructionActivityTaskLength(calcResultDetails) {
            return Math.max(...calcResultDetails.map(calcResultDetail => this.getConstructionActivityTask(calcResultDetail).length))
        },
        getExceeding(building) {
            if (building.othernoisecriteriaexceedmax == "") {
                return (Math.round(building.highestnoiselevel * 10) / 10) >
                    building.noiseCriteria ?
                    (Math.round(((Math.round(building.highestnoiselevel * 10) / 10) -
                        building.noiseCriteria) * 10)
                        / 10) : "-"
            }
            else {
                let criteria = Number(building.othernoisecriteriaexceedmax.split(":")[1].trim());
                return (Math.round(building.highestnoiselevel * 10) / 10) >
                    criteria ?
                    (Math.round(((Math.round(building.highestnoiselevel * 10) / 10) -
                        criteria) * 10)
                        / 10) : "-"
            }
        },
        getExceedingDuration(building) {
            let zoneTasks = [];
            Object.keys(building.zonetaskorcombined).forEach(zoneTask => {
                if (building.zonetaskorcombined[zoneTask].cnl > building.noiseCriteria) {
                    zoneTasks.push(...zoneTask.split("+"))
                }
            })
            let filtered = this.project.tasks.filter(t => zoneTasks.includes(`${t.zone}-${t.id}`));
            if (building.othernoisecriteriaexceedmax != "") {
                for (var i = 0; i < building.othernoisecriteriaexceed.length; i++) {
                    if (Number(building.othernoisecriteriaexceed[i].split(":")[1].trim()) < building.highestnoiselevel)
                        filtered.push({
                            start: Date.parse(building.othernoisecriteriaexceed[i].split("~")[0].trim()),
                            end: Date.parse(building.othernoisecriteriaexceed[i].split("~")[1].split(":")[0].trim())
                        })
                }
            }
            let start = new Date(Math.min(
                ...filtered.map(element => {
                    return DateHelper.getDate(element.start);
                }),
            ));
            let end = new Date(Math.max(
                ...filtered.map(element => {
                    return DateHelper.getDate(element.end);
                }),
            ));
            return ((end.getTime() - start.getTime()) / (1000 * 3600 * 24)).toFixed(1);
        },
        splitToPages(list, firstPageCount, otherPageCount) {
            let pages = []
            let sublist = [];
            for (var i = 0; i < list.length; i++) {
                if ((i + 1 - firstPageCount) % otherPageCount == 0) {
                    sublist.push(list[i])
                    pages.push(sublist);
                    sublist = [];
                }
                else {
                    sublist.push(list[i])
                }
            }
            if (sublist.length > 0) {
                pages.push(sublist);
            }
            return pages;
        },
    },
    mounted() {
        let props = this;
        this.project.equipments.forEach(e => {
            if (e.isQCM) {
                if (this.qcmList.filter(item => item.activity == this.getTaskName(e.task) && item.name == e.qpmename).length == 0) {
                    this.qcmList.push({
                        activity: this.getTaskName(e.task),
                        name: e.qpmename
                    })
                }
            }
            if (!e.isQCM && e.qpmename != '') {
                if (this.qpmeList.filter(item => item.activity == this.getTaskName(e.task) && item.name == e.qpmename).length == 0) {
                    this.qpmeList.push({
                        activity: this.getTaskName(e.task),
                        name: e.qpmename
                    })
                }
            }
            if (e.enclosureDba != 0) {
                if (this.mitigationList.filter(item => item.activity == this.getTaskName(e.task) && item.name == "Construction Noise Enclosure").length == 0) {
                    this.mitigationList.push({
                        activity: this.getTaskName(e.task),
                        name: "Construction Noise Enclosure"
                    })
                }
            }
            if (e.barrierDba != 0) {
                if (this.mitigationList.filter(item => item.activity == this.getTaskName(e.task) && item.name == "Noise Barrier").length == 0) {
                    this.mitigationList.push({
                        activity: this.getTaskName(e.task),
                        name: "Noise Barrier"
                    })
                }
            }
            if (e.custommethoddba != 0) {
                if (this.mitigationList.filter(item => item.activity == this.getTaskName(e.task) && item.name == e.custommethodname).length == 0) {
                    this.mitigationList.push({
                        activity: this.getTaskName(e.task),
                        name: e.custommethodname
                    })
                }
            }
        });
        props.qcmList.sort((a, b) => {
            return (a.activity + a.name).localeCompare(b.activity + b.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            })
        });
        props.qpmeList.sort((a, b) => {
            return (a.activity + a.name).localeCompare(b.activity + b.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            })
        });
        props.mitigationList.sort((a, b) => {
            return (a.activity + a.name).localeCompare(b.activity + b.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            })
        });
        let rowData = [];
        this.project.calcResultDetailsUnmitigated.forEach(calcResultDetail => {
            let constructionActivity = this.getConstructionActivity(calcResultDetail.taskid) == "-" ? this.getTaskName(calcResultDetail.taskid) : `${this.getConstructionActivity(calcResultDetail.taskid)} - ${this.getTaskName(calcResultDetail.taskid)}`;
            let pme = calcResultDetail.pmeref != '' ? `${calcResultDetail.pmeref} - ${calcResultDetail.pmename}` : calcResultDetail.pmename;
            let qty = calcResultDetail.qty;
            let swl = calcResultDetail.swl;
            let timePercent = calcResultDetail.timepercent;
            let totalswl = Math.round(calcResultDetail.totalswl);
            let data = `${constructionActivity} ${pme} ${swl} ${qty} ${timePercent} ${totalswl}`
            if (!rowData.includes(data)) {
                this.calcResultDetailsUnmitigatedCleaned.push(calcResultDetail);
                rowData.push(data);
            }
        });
        this.calcResultDetailsUnmitigatedCleaned.sort((a, b) => {
            let constructionActivityA = this.getConstructionActivity(a.taskid) == "-" ? this.getTaskName(a.taskid) : `${this.getConstructionActivity(a.taskid)} - ${this.getTaskName(a.taskid)}`;
            let pmeA = a.pmeref != '' ? `${a.pmeref} - ${a.pmename}` : a.pmename;
            let qtyA = a.qty;
            let timePercentA = a.timepercent;
            let constructionActivityB = this.getConstructionActivity(b.taskid) == "-" ? this.getTaskName(b.taskid) : `${this.getConstructionActivity(b.taskid)} - ${this.getTaskName(b.taskid)}`;
            let pmeB = b.pmeref != '' ? `${b.pmeref} - ${b.pmename}` : b.pmename;
            let qtyB = b.qty;
            let timePercentB = b.timepercent;
            return (constructionActivityA + pmeA + qtyA + timePercentA).localeCompare(
                (constructionActivityB + pmeB + qtyB + timePercentB), undefined, {
                numeric: true,
                sensitivity: 'base'
            })
        });
        [...new Set(this.project.calcResultNSRUnmitigated.map(item => item.nsrpointid))].forEach(nsrpointid => {
            let filtered = props.project.calcResultNSRUnmitigated.filter(item => item.nsrpointid == nsrpointid);
            props.nsrUnmitigated[nsrpointid] = {
                buildingid: filtered[0].buildingid,
                buildingName: filtered[0].buildingName,
                nsrname: filtered[0].nsrname,
                highestnoiselevel: filtered[0].highestnoiselevel,
                highestnoiselevelwithneighbour: Math.max(...filtered.map(f => f.highestnoiselevelwithneighbour)),
                noiseCriteria: filtered[0].noiseCriteria,
                zonetaskorcombined: {},
                othernoisecriteriaexceed: filtered[0].othernoisecriteriaexceed.split("#"),
                othernoisecriteriaexceedmax: filtered[0].othernoisecriteriaexceedmax,
            }
            filtered.forEach(result => {
                props.nsrUnmitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined] = {
                    cnl: result.cnl,
                    distance: result.distance,
                    distancecorr: result.distancecorr,
                    facadecorr: result.facadecorr,
                }
            })
        });
        [...new Set(this.project.calcResultNSRMitigated.map(item => item.nsrpointid))].sort().forEach(nsrpointid => {
            let filtered = props.project.calcResultNSRMitigated.filter(item => item.nsrpointid == nsrpointid)
            props.nsrMitigated[nsrpointid] = {
                buildingid: filtered[0].buildingid,
                buildingName: filtered[0].buildingName,
                nsrname: filtered[0].nsrname,
                nsrpointid: filtered[0].nsrpointid,
                highestnoiselevel: filtered[0].highestnoiselevel,
                noiseCriteria: filtered[0].noiseCriteria,
                othernoisecriteriaexceed: filtered[0].othernoisecriteriaexceed.split("#"),
                othernoisecriteriaexceedmax: filtered[0].othernoisecriteriaexceedmax,
                zonetaskorcombined: {}
            }
            filtered.forEach(result => {
                props.nsrMitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined] = {
                    cnl: result.cnl,
                    distance: result.distance,
                    distancecorr: result.distancecorr,
                    facadecorr: result.facadecorr,
                }
            })
        });
        this.project.tasks.sort((a, b) => (this.project.zones.filter(z => z.id == a.zone)[0].name + a.group + a.start).localeCompare(
            this.project.zones.filter(z => z.id == b.zone)[0].name + b.group + b.start, undefined, {
            numeric: true,
            sensitivity: 'base'
        }));
        console.log(props.nsrUnmitigated);
    },
    components: {
        InputLabel,
        DropdownLabel
    }
}
</script>

<style lang="less" scoped>
#report {
    font-family: 'Times New Roman', Times, serif;
    text-align: left;
    color: black;
}

.center {
    text-align: center;
    width: 100%;
}

.page {
    width: 100%;
    height: auto;
    aspect-ratio: 592.28/ 841.89;
    padding: 20px 15px;
    font-family: 'Times New Roman', Times, serif;
    text-align: left;
    color: black;
}

.landscapePage {
    width: 100%;
    height: auto;
    aspect-ratio: 841.89/592.28;
    padding: 20px 15px;
}

.table {
    width: 100%;
    font-size: 12px;
    margin-bottom: 10px;
}

table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

td {
    padding: 3px
}

.header {
    background-color: rgb(172, 172, 172);
    text-align: center;
    width: 100%;
}

.header>th {
    font-size: 12px;
}

.sub-header {
    text-align: center;
    font-weight: bold;
}

.cell {
    width: 100%;
}

.greyCell {
    background-color: rgb(172, 172, 172);
}

#gantt>tr>td:first-child {
    width: 33%;
}

.number {
    text-align: center
}

.css-table {
    display: table;
    border-collapse: collapse;
    // border: black 0.5px solid;
}

.css-tr {
    display: table-row;
    // border: black 0.5px solid;
}

.css-th {
    display: table-cell;
    font-weight: bold;
    border: black 1px solid;
    padding: 2px;
}

.css-td {
    display: table-cell;
    border: black 1px solid;
    padding: 2px;
}
</style>